import React, { useEffect, useState } from 'react';

import styles from './DogCardHareTests.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../../Auth';
import { useAxios } from '../../../../../../AxiosHandler';
import Card from '../../../../../Shared/Card/Card';
import BarGraphCard from '../../../../Statistics/Cards/BarGraphCard/BarGraphCard';

function DogCardHareTests(props: DogCardHareTestsProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [data, setData] = useState<any>();

    const [openTest, setOpenTest] = useState<string>("");
    
    function getData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/use/hare/tests",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setData(res.data);
            props.onDataLoaded?.(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    useEffect(() => {
        getData();
    }, [props.dogId]);

    return (
        <div className={styles.statisticsharetests}>
            <Card
                title={t("dog.statistics.haretests.title")}
                children={<div>
                    {data?.map((item: any, index: any) => {
                        let date = new Date(item["TEST_DATE"]);
                        let year = date.getFullYear();

                        // Day padded with 0
                        let day = ("0" + date.getDate()).slice(-2);

                        // Month padded with 0
                        let month = ("0" + (date.getMonth() + 1)).slice(-2);

                        return <div
                            key={item["ID"] + "_" + index}
                            className={styles.test}
                        >
                            <div
                                className={styles.testheader}
                                onClick={() => setOpenTest(openTest == (item["ID"] + "_" + index) ? "" : (item["ID"] + "_" + index))}
                            >
                                <div className={styles.testdate}>
                                    <span>{day}.{month}</span>
                                    <span>{year}</span>
                                </div>
                                <div className={styles.testname}>
                                    <span>{item["TEST_ID"]}</span>
                                </div>
                                <div className={styles.testresult}>
                                    <span>
                                        {item["PRIZE"] != 0 ?
                                            t("dog.statistics.haretests.results.prize") + ": " + item["PRIZE"] + ". " + t("dog.statistics.haretests.results.place")
                                        : <strong>&nbsp;</strong>}
                                    </span>
                                    <span>
                                        {t("dog.statistics.haretests.results.points")}: {item["KONKURANSEPOENG"]}
                                    </span>
                                </div>
                            </div>
                            <div className={styles.testcontent} style={{ display: openTest == (item["ID"] + "_" + index) ? "block" : "none" }}>
                                <BarGraphCard
                                    title=''
                                    data={{
                                        labels: [
                                            t("dog.statistics.haretests.results.labels.JAKTLYST"),
                                            t("dog.statistics.haretests.results.labels.SAMARBEID"),
                                            t("dog.statistics.haretests.results.labels.FOTARBEID"),
                                            t("dog.statistics.haretests.results.labels.MAALBRUK_FOT"),
                                            t("dog.statistics.haretests.results.labels.MAALBRUK_TAP"),
                                            t("dog.statistics.haretests.results.labels.ARBEID_LOS"),
                                            t("dog.statistics.haretests.results.labels.ARBEID_TAP"),
                                            t("dog.statistics.haretests.results.labels.MAAL_NYANSERING"),
                                            t("dog.statistics.haretests.results.labels.MAAL_HORBARHET"),
                                            t("dog.statistics.haretests.results.labels.KONDISJON"),
                                            t("dog.statistics.haretests.results.labels.LYDIGHET"),
                                        ],
                                        datasets: [
                                            {
                                                label: t("dog.statistics.haretests.results.title"),
                                                data: [
                                                    item["JAKTLYST"],
                                                    item["SAMARBEID"],
                                                    item["FOTARBEID"],
                                                    item["MAALBRUK_FOT"],
                                                    item["MAALBRUK_TAP"],
                                                    item["ARBEID_LOS"],
                                                    item["ARBEID_TAP"],
                                                    item["MAAL_NYANSERING"],
                                                    item["MAAL_HORBARHET"],
                                                    item["KONDISJON"],
                                                    item["LYDIGHET"],
                                                ],
                                                backgroundColor: "#68db5a",
                                            }
                                        ]
                                    }}
                                    options={{
                                        plugins: {
                                            legend: {
                                                display: true
                                            }
                                        },
                                        scales: {
                                            y: {
                                                suggestedMax: 10,
                                                suggestedMin: 0,
                                                beginAtZero: true,
                                            }
                                        }
                                    }}
                                ></BarGraphCard>
                            </div>
                        </div>;
                    })}
                </div>}
            />
        </div>
    );
}

class DogCardHareTestsProps {
    dogId!: string | undefined;
    onDataLoaded?: (data: any) => void;
}

export default DogCardHareTests;